const CHANGE_STEP   = "CHANGE_STEP";
const SET_NEXT_STEP = "SET_NEXT_STEP";
const SET_VARIETY   = "SET_VARIETY";
const CHOOSE_TARGET = "CHOOSE_TARGET";
const SET_TARGETS   = "SET_TARGETS";
const SCROLL_TO_STEP   = "SCROLL_TO_STEP";

const initialState = {
    nextStep: 1,
    history:[1],
    variety: null,
    targetID: null,
    targets: [],
    deadline: null,
    deadline_list:[
        "ASAP",
        "I have 1-2 months to hire talents",
        "I’m looking to hire a dream team, so take your time"
    ],
    settings:[
        {name: "Location", class_name:"location", id: 1, icon: 'map marker alternate'},
        {name: "Type", class_name:"type", id: 2, icon: 'map signs'},
        {name: "Target", class_name:"target", id: 3, icon: 'target'},
        {name: "My Team", class_name:"team", id: 4, icon: 'users'},
        //{name: "My Project", class_name:"project", id: 5, icon: 'briefcase'},
        {name: "Deadline", class_name:"deadline", id: 6, icon: 'time'},
        {name: "Contact", class_name:"contact", id: 7, icon: 'address card outline'}
    ]
};

/**
 * Start Callbacks
 **/

function changeStep(state){
    const stateCopy = JSON.parse(JSON.stringify(state));
    if(stateCopy.history.indexOf(stateCopy.nextStep) === -1) {
        stateCopy.history.push(stateCopy.nextStep);
    }

    return stateCopy;
}

function setNextStep(state, nextStep) {
    const stateCopy = JSON.parse(JSON.stringify(state));
    stateCopy.nextStep = nextStep;
    return stateCopy;
}

function setVariety(state, variety) {
    const stateCopy = JSON.parse(JSON.stringify(state));
    stateCopy.variety = variety;
    return stateCopy;
}

function ChooseTarget(state, e, { value, target }) {
    const stateCopy = JSON.parse(JSON.stringify(state));
    stateCopy[target] = value;
    return stateCopy;
}

function setTargets(state, targets) {
    const stateCopy = JSON.parse(JSON.stringify(state));
    stateCopy.targets = targets;
    return stateCopy;
}

function scrollToStep(state, stepId) {
    const stateCopy = JSON.parse(JSON.stringify(state));
    stateCopy.nextStep = stepId;
    return stateCopy;
}

/**
 * End of Callbacks
 **/

const flowReducer = (state = initialState, action) => {

    switch (action.type) {
        case CHANGE_STEP:
            return changeStep(state);
        case SET_NEXT_STEP:
            return setNextStep(state,action.nextStep);
        case SET_VARIETY:
            return setVariety(state,action.variety);
        case CHOOSE_TARGET:
            return ChooseTarget(state, action.event, action.target);
        case SET_TARGETS:
            return setTargets(state, action.targets);
        case SCROLL_TO_STEP:
            return scrollToStep(state, action.stepId);
        default:
            return state;
    }
};

/**
 * ACTIONS
 */

export function changeStepAction() {
    return {type: CHANGE_STEP};
}
export function setNextStepAction(nextStep) {
    return {type: SET_NEXT_STEP, nextStep};
}
export function setVarietyAction(variety) {
    return {type: SET_VARIETY, variety};
}
export function ChooseTargetAction(event, target) {
    return {type: CHOOSE_TARGET, event, target};
}
export function setTargetsAction(targets) {
    return {type: SET_TARGETS, targets};
}
export function scrollToStepAction(stepId) {
    return {type: SCROLL_TO_STEP, stepId};
}

export default flowReducer;